// extracted by mini-css-extract-plugin
export var option = "_ch-0";
export var optionCard = "_ch-f";
export var optionContent = "_ch-g";
export var optionIcon = "_ch-i";
export var optionIconBox = "_ch-h";
export var optionLabel = "_ch-j";
export var optionPill = "_ch-m";
export var optionPillBadge = "_ch-p";
export var optionPillIcon = "_ch-n";
export var optionPillLabel = "_ch-o";
export var optionRadio = "_ch-k";
export var optionRadioInner = "_ch-l";
export var optionReveal = "_ch-2";
export var optionRevealDelay0 = "_ch-3";
export var optionRevealDelay1 = "_ch-4";
export var optionRevealDelay10 = "_ch-d";
export var optionRevealDelay11 = "_ch-e";
export var optionRevealDelay2 = "_ch-5";
export var optionRevealDelay3 = "_ch-6";
export var optionRevealDelay4 = "_ch-7";
export var optionRevealDelay5 = "_ch-8";
export var optionRevealDelay6 = "_ch-9";
export var optionRevealDelay7 = "_ch-a";
export var optionRevealDelay8 = "_ch-b";
export var optionRevealDelay9 = "_ch-c";
export var optionSelected = "_ch-1";